import { useState } from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import { reExportedColors, Text } from '../../1elements'
import { englishTexts } from '../../../consts/Texts'
import UploadLinkButton from '../../1elements/Buttons/TextButtons/UploadLinkButton/UploadLinkButton'

const ImageUploadLink = ({ setEditMode }) => {
  const theme = useTheme()
  const [error] = useState('')

  return (
    <div>
      <Box sx={{
        alignItems: 'center',
        border: '1px grey dotted',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        height: '130px',
        justifyContent: 'center',
        position: 'relative',
        width: '190px'
      }}>
        <Box sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          marginTop: '10px',
          '& > *': { marginTop: '5px' }
        }}>
          <UploadLinkButton onClick={() => setEditMode(true)} />
          <Text
            type='h6'
            style={{ color: theme.palette.tertiary.accent, textAlign: 'center' }}
          >
            {englishTexts.imageUploader.finePrint}
          </Text>
          <Text type='h6' style={{ color: reExportedColors.RED }}>{error}</Text>
        </Box>
      </Box>
    </div>
  )
}

export default ImageUploadLink
